<template>
  <div class="main-content">
    <el-card class="preview">
      <div>
        <h2>{{ release.title }}</h2>
        <div class="author">
          {{ release.author.screen_name }}
          <template v-if="published"
            >发布于 {{ release.published_at | parseTime }}</template
          >
        </div>
        <div class="mt-10">
          <template v-for="(tag, idx) of release.tags">
            <el-tag :key="idx" size="mini" type="info">{{ tag.name }}</el-tag>
          </template>
        </div>
        <hr />
        <TextEditorPreview :content="release.readme"></TextEditorPreview>
      </div>
      <hr />
      <div class="repos">
        <div class="repo" :key="repo.id" v-for="repo of release.repos">
          <div class="repo-prefix"></div>
          <RepoPreview class="repo-preview" :repo_id="repo.id"></RepoPreview>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { ReleaseMixin, ParseTimeFilterMixin } from "@/mixins";
import TextEditorPreview from "@/components/TextEditorPreview";
import RepoPreview from "@/components/RepoPreview";
export default {
  name: "ReleasePreview",
  mixins: [ReleaseMixin, ParseTimeFilterMixin],
  components: {
    TextEditorPreview,
    RepoPreview
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles.scss";
.repos {
  /deep/.ql-editor {
    min-height: 10px;
  }
}
.repo {
  position: relative;
}
.repo + .repo {
  margin-top: 30px;
  border-top: 1px solid #e1e1e1;
  padding-top: 10px;
}
.repo-prefix {
  position: absolute;
  left: 10px;
  height: 100%;
  width: 6px;
  background-color: rgba(0, 160, 255, 0.4);
  border-radius: 20px;
}
.repo-preview {
  margin-left: 50px;
}
</style>
